import FilterForm from '../../components/forms/FilterForm';
import { CanAccess, CrudFilters, HttpError, useCan } from '@refinedev/core';
import { EditButton, TextField, useTable } from '@refinedev/antd';
import { Form, Input, Table } from 'antd';
import { IExternalItem } from 'interfaces/external_items';
import { ListLayout } from 'components/layout/layout/ListLayout';
import { formatDate } from 'services/date';

interface IFilter {
  name: string;
}

export const ExternalItemList = () => {
  const { data: canCreate } = useCan({
    resource: 'external_items',
    action: 'create'
  });

  const { tableProps, searchFormProps } = useTable<
    IExternalItem,
    HttpError,
    IFilter
  >({
    onSearch: params => {
      const filters: CrudFilters = [];
      const { name } = params;

      filters.push({
        field: 'filter[name]',
        operator: 'eq',
        value: name
      });

      return filters;
    },
    sorters: {
      mode: 'server'
    }
  });

  return (
    <ListLayout title="Itens externos" canCreate={Boolean(canCreate?.can)}>
      <FilterForm searchFormProps={searchFormProps}>
        <Form.Item name="name">
          <Input
            placeholder="Buscar por nome do item"
            className="min-w-[300px]"
          />
        </Form.Item>
      </FilterForm>

      <Table {...tableProps} rowKey="id">
        <Table.Column
          dataIndex="name"
          key="name"
          title="Nome"
          render={value => <TextField value={value} />}
        />
        <Table.Column
          dataIndex="webhook_url"
          key="webhook_url"
          title="URL do Webhook"
          render={value => (
            <TextField
              value={value?.length > 50 ? `${value.slice(0, 50)}...` : value}
            />
          )}
        />
        <Table.Column
          dataIndex="access_url"
          key="access_url"
          title="URL de Acesso"
          render={value => (
            <TextField
              value={value?.length > 50 ? `${value.slice(0, 50)}...` : value}
            />
          )}
        />
        <Table.Column
          dataIndex="duration_in_hours"
          key="duration_in_hours"
          title="Duração (horas)"
          render={value => <TextField value={value || '-'} />}
        />
        <Table.Column
          dataIndex="created_at"
          key="created_at"
          title="Criado em"
          render={value => <TextField value={formatDate(value)} />}
        />
        <Table.Column<IExternalItem>
          title="Ações"
          dataIndex="actions"
          width={80}
          render={(_, record) => (
            <CanAccess resource="external_items" action="show">
              <EditButton hideText size="small" recordItemId={record.id} />
            </CanAccess>
          )}
        />
      </Table>
    </ListLayout>
  );
};
